import React, { FC } from 'react';
import { AutocompleteResult } from 'app/models/types/store/location';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'app/hooks/useTranslations';
import styles from './Autocomplete.scss';
import { removeRecentCity } from 'app/store/actions';
import { Icon, IconClose } from 'app/icons';

export const RemoveButton: FC<{
  city: AutocompleteResult;
  direction: 'from' | 'to';
}> = ({ city, direction }) => {
  const dispatch = useDispatch();
  const { getRemoveLabel } = useTranslations({
    getRemoveLabel: 'search_mask.label.remove',
  });

  return (
    <button
      tabIndex={-1}
      aria-label={getRemoveLabel()}
      className={styles.removeIcon}
      onClick={(e) => {
        e.stopPropagation();
        dispatch(removeRecentCity(direction, city.id));
      }}
    >
      <Icon appearance="primary" InlineIcon={IconClose} extraClasses={styles.resetLeft} />
    </button>
  );
};
